import request from "@/utils/request";

// 获取加密的验证码
export function getValidCodeFun(data) {
  return request({
    url: `/fmsapi/common/GetValidCodeDESEncrypt`,
    method: "post",
    data,
  });
}

// 获取加密的验证码
export function getTokenFun(data) {
  return request({
    url: `/fmsapi/common/GetToken`,
    method: "post",
    data,
  });
}

// 获取验证码图片
export function getValidateCodeFun(data) {
  return request({
    url: `/fmsapi/common/GetValidateCode`,
    method: "post",
    data,
    responseType: 'arraybuffer'
  });
}
// 发送手机/邮箱验证码
export function getValidateCodeApi(data) {
  return request({
    url: `/fmsapi/common/AddValidCodeThenSend`,
    method: "post",
    data,
  });
}
// 校验手机/邮箱验证码
export function checkValidateCodeApi(data) {
  return request({
    url: `/fmsapi/common/CheckValidateCode`,
    method: "post",
    data,
  });
}
//选择公司时初始化公司数据
export function initUserCompanyApi(data) {
  return request({
    url: `/fmsapi/Common/InitUserCompany`,
    method: "post",
    data,
  });
}
// 货币类型
export function getCurrencyApi(data) {
  return request({
    url: `/fmsapi/common/GetSearchCurrency`,
    method: "post",
    data,
  });
}

// 国家
export function getAddressListApi(data) {
  return request({
    url: `/fmsapi/common/GetAddressList`,
    method: "post",
    data,
  });
}

// 省
export function getProvinceApi(data) {
  return request({
    url: `/fmsapi/common/GetRegisterProvince`,
    method: "post",
    data,
  });
}

// 市
export function getCityApi(data) {
  return request({
    url: `/fmsapi/common/GetRegisterCity`,
    method: "post",
    data,
  });
}
//根据税种获取税率
export function getTaxListByCategoryApi(data) {
  return request({
    url: `/fmsapi/common/GetTaxListByCategory`,
    method: "post",
    data,
  });
}
//获取供应商列表
export function getSupplierApi(data) {
  return request({
    url: `/fmsapi/Common/GetSupplier`,
    method: "post",
    data,
  });
}
//获取合作伙伴列表
export function getPartnersAllApi(data) {
  return request({
    url: `/fmsapi/Common/GetPartnersAll`,
    method: "post",
    data,
  });
}
//获取币值种类
export function getSearchCurrencyApi(data) {
  return request({
    url: `/fmsapi/Common/GetSearchCurrency`,
    method: "post",
    data,
  });
}
//获取单个税种
export function getTaxOneApi(data) {
  return request({
    url: `/fmsapi/Common/GetTaxOne`,
    method: "post",
    data,
  });
}
//提交获取人员列表
export function getStaffListApi(data) {
  return request({
    url: `/fmsapi/Common/GetStaffList`,
    method: "post",
    data,
  });
}
//获取申请人员列表
export function getApplyUserListApi(data) {
  return request({
    url: `/fmsapi/Common/GetApplyUserList`,
    method: "post",
    data,
  });
}
//获取启用自定义流程
export function getDiyProcessListApi(data) {
  return request({
    url: `/fmsapi/Common/GetDiyProcessList`,
    method: "post",
    data,
  });
}
//获取模板流程字段
export function getDiyProcessColsApi(data) {
  return request({
    url: `/fmsapi/Common/GetDiyProcessCols`,
    method: "post",
    data,
  });
}
//上传附件图片
export function fileUploadApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/FileUpload`,
    method: "post",
    headers:{
      'Content-Type': 'multipart/form-data'
    },
    data,
  });
}
//上传附件到ocr
export function fileUploadStreamApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/FileUploadStream`,
    method: "post",
    headers:{
      'Content-Type': 'multipart/form-data'
    },
    data,
  });
}

//获取员工办公地点
export function getStatffOfficeAddrApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/GetStatffOfficeAddr`,
    method: "post",
    data,
  });
}
//签入签出
export function ValidateLocationApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/ValidateLocation`,
    method: "post",
    data,
  });
}
//获取最后一次打卡记录
export function getLastOfficesApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/GetLastRecord`,
    method: "post",
    data,
  });
}
//高德坐标转换
export function CoordConvertRequestApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/CoordConvertRequest`,
    method: "post",
    data,
  });
}

//初始化微信，获取签名
export function GetNetBooktokenApi(data) {
  return request({
    url: `/fmsapi/common/GetNetbookacctokenNew`,
    method: "post",
    data,
  });
}

//获取今天，出差记录
export function GetApplyFormFLReadyApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/GetApplyFormFLReadyLocations`,
    method: "post",
    data,
  });
}

//获取今天，出差最后一次签入/签出数据
export function GetApplyLocationsLastRecordApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/GetApplyLocationsLastRecord`,
    method: "post",
    data,
  });
}

//出差签入/签出
export function ValidateApplyLocationsApi(data) {
  return request({
    url: `/fmsapi/CheckLocations/ValidateApplyLocations`,
    method: "post",
    data,
  });
}
//根据岗位获取所属部门
export function getDepartmentByPostApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/GetDepartmentByPost`,
    method: "post",
    data,
  });
}
//获取假勤管理中设置的假期最小时间段
export function getLeaveValidityPeriodApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/GetLeaveValidityPeriod`,
    method: "post",
    data,
  });
}
//检查外币汇率是否设置
export function checkRateApi(data) {
  return request({
    url: `/fmsapi/InternalAPI/CheckRate`,
    method: "post",
    data,
  });
}



